import * as types from "../actions/actionTypes";
import initialState from "./initialState";

export default function groupMembershipsReducer(
  state = initialState.groupMemberships,
  action
) {
  
  switch (action.type) {
    case types.GET_GROUP_MEMBERSHIPS:
      return initialState.groupMemberships;
    case types.GET_GROUP_MEMBERSHIPS_SUCCESS:
      return action.groupMemberships;
    case types.GET_GROUP_MEMBERSHIPS_FAILED:
      return action.error;
    default:
      return state;
  }
}
